export const EVENT_GO_TO_SIGNUP = 'EVENT_GO_TO_SIGNUP';
export const EVENT_DOWNLOAD_APP = 'EVENT_DOWNLOAD_APP';
export const EVENT_ACADEMY = 'EVENT_ACADEMY';
export const QA_TUTOR_PICKUP_Q = 'QA_TUTOR_PICKUP_Q';
export const QA_TUTOR_COMPLETE_Q = 'QA_TUTOR_COMPLETE_Q';



// WEBPACK FOOTER //
// ./src/constants/userTrackingEvents.js